import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import Navbar from "@/components/Navbar";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Loader2, ArrowLeft, ChevronLeft, ChevronRight, FileDown, FileText } from "lucide-react";
import { PaintOrdersTable, statementUrl } from "./PaintOrder";

const shift = (m, d) => {
  const [y, mo] = m.split("-").map(Number);
  const dt = new Date(y, mo - 1 + d, 1);
  return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}`;
};
const label = (m) => new Date(`${m}-01T00:00:00`).toLocaleDateString("en-AU", { month: "long", year: "numeric" });

export default function PaintHistory() {
  const navigate = useNavigate();
  const [month, setMonth] = useState("");
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/paint/orders${month ? `?month=${month}` : ""}`).then((r) => { setData(r.data); if (!month) setMonth(r.data.month); });
  }, [month]);

  if (!data) return <div className="flex min-h-screen items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>;
  const atCurrent = data.month >= data.current_month;

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="mx-auto max-w-4xl px-4 py-8 sm:px-6">
        <Button variant="ghost" size="sm" onClick={() => navigate("/paint")} data-testid="paint-history-back" className="gap-1.5"><ArrowLeft className="h-4 w-4" /> Back to orders</Button>
        <h1 className="mt-2 font-heading text-2xl font-extrabold tracking-tight text-kilted-green sm:text-3xl" data-testid="paint-history-heading">Monthly history</h1>

        <div className="mt-4 flex items-center justify-between gap-3">
          <Button size="lg" variant="outline" onClick={() => setMonth(shift(data.month, -1))} data-testid="paint-prev-month" className="h-14 flex-1 gap-2 text-base font-bold"><ChevronLeft className="h-5 w-5" /> Previous</Button>
          <div className="text-center">
            <p className="font-heading text-lg font-extrabold text-kilted-green" data-testid="paint-history-month">{label(data.month)}</p>
            <p className="text-xs text-muted-foreground" data-testid="paint-history-tally">{data.tally.count} orders · ${data.tally.total.toFixed(2)}</p>
          </div>
          <Button size="lg" variant="outline" disabled={atCurrent} onClick={() => setMonth(shift(data.month, 1))} data-testid="paint-next-month" className="h-14 flex-1 gap-2 text-base font-bold">Next <ChevronRight className="h-5 w-5" /></Button>
        </div>

        <div className="mt-3 flex justify-end gap-2">
          <Button variant="outline" size="sm" onClick={() => statementUrl(data.month, "csv")} data-testid="paint-history-csv" className="gap-1.5"><FileDown className="h-3.5 w-3.5" /> CSV</Button>
          <Button variant="outline" size="sm" onClick={() => statementUrl(data.month, "pdf")} data-testid="paint-history-pdf" className="gap-1.5"><FileText className="h-3.5 w-3.5" /> PDF</Button>
        </div>

        <Card className="mt-4">
          <CardHeader><CardTitle className="text-base">Orders</CardTitle></CardHeader>
          <CardContent><PaintOrdersTable orders={data.orders} /></CardContent>
        </Card>
      </main>
    </div>
  );
}
